var _rect, _path, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgEmailCircle(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 50,
    viewBox: "0 0 50 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 50,
    height: 50,
    rx: 25,
    fill: "url(#paint0_linear_430_1548)"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.7653 18.7453L23.7653 24.2132C24.1013 24.3964 24.536 24.4833 24.9733 24.4833C25.4107 24.4833 25.8453 24.3964 26.1813 24.2132L36.1813 18.7453C36.8333 18.3884 37.4493 17 36.2533 17H13.6947C12.4987 17 13.1147 18.3884 13.7653 18.7453ZM36.484 21.7351L26.1813 27.2003C25.728 27.4419 25.4107 27.4704 24.9733 27.4704C24.536 27.4704 24.2187 27.4419 23.7653 27.2003C23.312 26.9587 14.2547 22.1259 13.5147 21.7337C12.9947 21.4569 13 21.7812 13 22.0309V31.9286C13 32.4986 13.7547 33.2857 14.3333 33.2857H35.6667C36.2453 33.2857 37 32.4986 37 31.9286V22.0323C37 21.7826 37.0053 21.4582 36.484 21.7351Z",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_430_1548",
    x1: 25,
    y1: 0,
    x2: 25,
    y2: 50,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#446DFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2F5DFF"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmailCircle);
export default __webpack_public_path__ + "static/media/emailCircle.1f68a75c2ecedb5f5c1e487dbd186bad.svg";
export { ForwardRef as ReactComponent };